import { Inbox } from 'lucide-react'
import { useColors } from '../../hooks/useColors'

interface EmptyStateProps {
  icon?: React.ComponentType<{ size: number; color: string }>
  title: string
  description?: string
}

export default function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
}: EmptyStateProps) {
  const colors = useColors()

  return (
    <div
      style={{
        padding: '48px 24px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <Icon size={40} color={colors.textMuted} />
      <p
        className="font-display"
        style={{
          margin: 0,
          fontSize: '16px',
          fontWeight: 600,
          color: colors.textPrimary,
        }}
      >
        {title}
      </p>
      {description && (
        <p
          className="font-body"
          style={{
            margin: 0,
            fontSize: '13px',
            color: colors.textSecondary,
            maxWidth: '400px',
          }}
        >
          {description}
        </p>
      )}
    </div>
  )
}
